import {ReducerStatuses} from "services/utils/utils";
import {createSlice} from "@reduxjs/toolkit";
import {commentSet} from "features/components/comment-field/reducer";

export const initialState = {
    status: ReducerStatuses.IDLE,
    error: "",
    search: "",
    data: [],
    hide: true
};

const slice = createSlice({
    name: "commentAutosuggest",
    initialState,
    reducers: {
        autosuggestCommentHide: (state) => {
            state.hide = true;
        },
        autosuggestCommentFailure: (state, {payload}) => {
            state.status = ReducerStatuses.ERROR;
            state.error = payload;
        },
        autosuggestCommentSuccess: (state, {payload}) => {
            state.status = ReducerStatuses.SUCCESS;
            state.data = payload;
        },
        autosuggestCommentUserSelected: (state) => {
            state.search = "";
            state.hide = true;
            state.status = ReducerStatuses.IDLE;
        }
    },
    extraReducers: {
        [commentSet]: (state, {payload}) => {
            const regex = /@([a-zA-Z0-9]+)$/;
            const matches = payload.match(regex);
            state.search = matches ? matches[1] : "";
            state.status = ReducerStatuses.LOADING;
            state.hide = false;
        }
    }
});

const { reducer, actions } = slice;

export const {
    autosuggestCommentFailure, autosuggestCommentHide, autosuggestCommentSuccess, autosuggestCommentUserSelected
} = actions;

export default reducer;